import withAuth from './withAuth';

export default withAuth;
